import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { CatalogProvider } from "./context/CatalogContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import AgeGateModal from "./components/AgeGateModal";
import AnnouncementBar from "./components/AnnouncementBar";
import PromoBanner from "./components/PromoBanner";
import WelcomeOfferBanner from "./components/WelcomeOfferBanner";
import Header from "./components/Header";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import ReviewOrder from "./pages/ReviewOrder";
import OrderConfirmation from "./pages/OrderConfirmation";
import About from "./pages/About";
import Faq from "./pages/Faq";
import Legal from "./pages/Legal";
import Lookbook from "./pages/Lookbook";
import Shipping from "./pages/Shipping";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Account from "./pages/Account";
import Admin from "./pages/Admin";
import RefundPolicy from "./pages/RefundPolicy";
import MarkShipped from "./pages/MarkShipped";
import Refund from "./pages/Refund";

import TestimonialsCarousel from "./components/GlobalTestimonials";
import FdaDisclaimerBanner from "./components/FdaDisclaimerBanner";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CatalogProvider>
          <CartProvider>
            <BrowserRouter>
            <ScrollToTop />
            <AgeGateModal />
            <AnnouncementBar />
            <PromoBanner />
            <WelcomeOfferBanner />
            <Header />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<Products />} />
              <Route path="/product/:slug" element={<ProductDetail />} />
              <Route
                path="/cart"
                element={
                  <ProtectedRoute>
                    <Cart />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/checkout/review"
                element={
                  <ProtectedRoute>
                    <ReviewOrder />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/order/:orderNumber"
                element={
                  <ProtectedRoute>
                    <OrderConfirmation />
                  </ProtectedRoute>
                }
              />
              <Route path="/about" element={<About />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/legal/:slug" element={<Legal />} />
              <Route path="/lookbook" element={<Lookbook />} />
              <Route path="/shipping" element={<Shipping />} />
              <Route path="/refund-policy" element={<RefundPolicy />} />
              <Route path="/mark-shipped/:token" element={<MarkShipped />} />
              <Route path="/refund/:token" element={<Refund />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route
                path="/account"
                element={
                  <ProtectedRoute>
                    <Account />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <AdminRoute>
                    <Admin />
                  </AdminRoute>
                }
              />
              <Route path="*" element={<Home />} />
            </Routes>
            <TestimonialsCarousel />
            <FdaDisclaimerBanner />
            <Footer />
          </BrowserRouter>
          </CartProvider>
        </CatalogProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
